<ng-container *ngIf="instance">
  <produit-forfait *ngIf="instance.id_si_forfait && instance.id_si_forfait > 0" 
    [produit_forfait_info]="instance"
    [id_instance]="instance.id_instance"
  ></produit-forfait>
  <service-ecole *ngIf="instance.id_si_b2b && instance.id_si_b2b > 0" 
    [service_ecole_info]="instance"
    [id_instance]="instance.id_instance"
  ></service-ecole>
</ng-container>